import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FollowupDashboardService {

  constructor(private ws: PostmethodService) { }

  getLeadSource(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardLeadSourceFilter");
  }

  getGeography(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardgeogrphicalFilter");
  }

  getStatus(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardCombineFilter");
  }

  getUser(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardUserFilter");
  }

  getProduct(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardProductFilter");
  }

  getZoneCounts(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/DashboardTatFollowup");
  }

  getGeographyChartCounts(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardTatFollowupGraph");
  }

  getLineChartCount(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardLineChartCount");
  }

  getParentDealerChartCount(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardParentDealerTatFollowupGraph");
  }
  
  getDealersAndOutlets(request:any){
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardParentOutletFilter");
  }

  geBarCounts(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardFollowupGraphCount");
  }

  geFollowupTableCounts(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/DashboardFollowupListCount");
  }

  getRegionalMgrs(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/regionalManagerFilter");
  }

  getAreaMgrs(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/areaManagerFilter");
  }
}
